
import cartMixin from '@/mixins/cartMixin.js';
export default {
  mixins: [cartMixin],
  data() {
    return {
      loadedCart: false,
      productsLimit: 3,
    };
  },
  computed: {
    promoCodes() {
      return this.cart?.Discounts?.PromoCodes;
    },
    products() {
      return this.cart?.Products;
    },
    productsCount() {
      return this.products?.length || 0;
    },
    visibleProducts() {
      return (this.products || []).slice(0, this.productsLimit);
    },
  },
  watch: {
    productsCount() {
      this.productsLimit = 3;
    },
  },
};
